import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import ListInfosPreview from "@project/components/ListInfos/ListInfosPreview";
export const ListInfosItem = {
    label: "Element de liste",
    key: "items",
    type: ContentsCustomTypes.LIST_INFOS_ITEM,
    children: [
        {
            label: "Libelle",
            key: "label",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
export const ListInfos = {
    label: "Liste d'infos",
    type: ContentsCustomTypes.LIST_INFOS,
    Preview: ListInfosPreview,
    icon: "th-large",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [ListInfosItem],
                    value: ContentsCustomTypes.LIST_INFOS_ITEM,
                },
            ],
        },
    ],
};
